const routes = [
  {
    path: '/dashboard',
    name: 'DashboardPage',
    auth: true,
    authPage: 'LoginPage',
    duckName: 'DashboardPage',
    loaders: {
      page: () => import('./containers/DashboardPage/DashboardPage'),
      duck: () => import('./ducks/DashboardPage.duck'),
    },
  },
];

export default routes;
